/* Free gift picker + auto-remove of excess gifts (snippets/free-gift.liquid). Runs once. */
(() => {
  'use strict';
  if (window.__dlFreeGift) return;
  window.__dlFreeGift = true;

  const T = window.theme || { routes: {}, strings: {} };
  const changeUrl = (T.routes.cartChange || '/cart/change') + '.js';
  const onCartPage = () => !!document.querySelector('[data-main-cart]');
  const toast = (msg) => {
    const el = document.querySelector('[data-toast]'); if (!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(el._t); el._t = setTimeout(() => { el.hidden = true; }, 2600);
  };
  const errMsg = () => {
    const b = document.querySelector('[data-fg]');
    return (b && b.getAttribute('data-error')) || T.strings.error || 'Something went wrong. Please try again.';
  };

  /* Test switch: add ?fg_preview=1 to any URL to show the block before launch (?fg_preview=0 turns it off). */
  try {
    const u = new URL(location.href), fp = u.searchParams.get('fg_preview');
    if (fp === '1' || fp === '0') {
      fetch((T.routes.cartUpdate || '/cart/update') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _fg_preview: fp === '1' ? '1' : '' } })
      }).then(() => { u.searchParams.delete('fg_preview'); location.replace(u.toString()); });
    }
  } catch (e) {}

  /* Hide the block outside the campaign window (server already does this; this covers cached HTML). */
  const checkWindow = () => {
    document.querySelectorAll('[data-fg]').forEach((b) => {
      if (b.hasAttribute('data-preview')) return;
      const s = Date.parse(b.getAttribute('data-start')), e = Date.parse(b.getAttribute('data-end'));
      const now = Date.now();
      if (!isNaN(s) && !isNaN(e) && (now < s || now >= e)) b.hidden = true;
    });
  };

  /* Add a gift */
  let busy = false;
  document.addEventListener('click', async (ev) => {
    const btn = ev.target.closest('[data-fg-add]'); if (!btn) return;
    ev.preventDefault();
    if (busy || btn.disabled) return;
    busy = true;
    document.querySelectorAll('[data-fg-add]').forEach((b) => { b.disabled = true; });
    btn.classList.add('is-loading');
    const items = [{ id: Number(btn.getAttribute('data-fg-add')), quantity: 1, properties: { _free_gift: '1' } }];
    try {
      if (onCartPage() || !(window.DL && window.DL.addToCart)) {
        const res = await fetch((T.routes.cartAdd || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || errMsg());
        location.reload();
        return;
      }
      await window.DL.addToCart(items, btn, null, true);
    } catch (err) {
      toast(err.message || errMsg());
    } finally {
      busy = false;
      document.querySelectorAll('[data-fg-add]').forEach((b) => { b.disabled = false; });
      btn.classList.remove('is-loading');
    }
  });

  /* "Choose your free gift" link in the drawer header scrolls to the picker */
  document.addEventListener('click', (ev) => {
    const j = ev.target.closest('[data-fg-jump]'); if (!j) return;
    const scope = j.closest('#CartDrawer') || document;
    const pk = scope.querySelector('[data-fg-picker]');
    if (!pk) return;
    const box = pk.closest('.drawer__body');
    if (box) box.scrollTo({ top: box.scrollTop + pk.getBoundingClientRect().top - box.getBoundingClientRect().top - 8, behavior: 'smooth' });
    else pk.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* Remove gifts the cart no longer qualifies for */
  let attempts = 0, fixing = false, lastSig = '';
  const fixExcess = async () => {
    const el = document.querySelector('[data-fg-excess]');
    if (!el || fixing) return;
    const sig = el.getAttribute('data-items') || '';
    if (sig !== lastSig) { lastSig = sig; attempts = 0; }
    if (attempts >= 3) return;
    let list; try { list = JSON.parse(sig || '[]'); } catch (e) { return; }
    if (!list.length) return;
    fixing = true; attempts += 1;
    let last = null;
    try {
      for (const it of list) {
        const res = await fetch(changeUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: it.qty, sections: ['cart-drawer'], sections_url: location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || errMsg());
        last = data;
      }
      if (onCartPage()) { location.reload(); return; }
      fixing = false;
      if (last && last.sections && window.DL && window.DL.renderCart) window.DL.renderCart(last.sections['cart-drawer']);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (err) {
      fixing = false;
    }
  };

  const run = () => { checkWindow(); fixExcess(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('cart:rendered', () => { setTimeout(run, 0); });
  /* Full cart page: theme.js swaps [data-main-cart] innerHTML without an event, so watch it. */
  const watchMain = () => {
    const m = document.querySelector('[data-main-cart]');
    if (!m || !window.MutationObserver) return;
    let t; new MutationObserver(() => { clearTimeout(t); t = setTimeout(run, 50); }).observe(m, { childList: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchMain); else watchMain();
})();
